module.exports = __webpack_public_path__ + "img/add-linear-24x24.16a0257a.svg";